import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { NotificationsProvider } from "@/context/NotificationsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Home from "@/pages/Home";
import News from "@/pages/News";
import Matches from "@/pages/Matches";
import MatchDetail from "@/pages/MatchDetail";
import Communications from "@/pages/Communications";
import Messages from "@/pages/Messages";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import CoachArea from "@/pages/CoachArea";

const ADMIN_ONLY = ["admin"];
const COACH_STAFF = ["admin", "coach"];

function RootRedirect() {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (!user) return <Navigate to="/login" replace />;
    return <Home />;
}

export default function App() {
    return (
        <div className="App">
            <SettingsProvider>
                <AuthProvider>
                    <NotificationsProvider>
                        <BrowserRouter>
                        <Routes>
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route
                                element={
                                    <ProtectedRoute>
                                        <Layout />
                                    </ProtectedRoute>
                                }
                            >
                                <Route index element={<RootRedirect />} />
                                <Route path="/news" element={<News />} />
                                <Route path="/partite" element={<Matches />} />
                                <Route path="/partite/:id" element={<MatchDetail />} />
                                <Route path="/comunicazioni" element={<Communications />} />
                                <Route path="/messaggi" element={<Messages />} />
                                <Route path="/profilo" element={<Profile />} />
                                <Route
                                    path="/allenatore"
                                    element={
                                        <ProtectedRoute roles={COACH_STAFF}>
                                            <CoachArea />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin"
                                    element={
                                        <ProtectedRoute roles={ADMIN_ONLY}>
                                            <Admin />
                                        </ProtectedRoute>
                                    }
                                />
                            </Route>
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </BrowserRouter>
                    </NotificationsProvider>
                </AuthProvider>
            </SettingsProvider>
            <Toaster position="top-center" richColors />
        </div>
    );
}
